import React, { useState, useEffect, useContext } from 'react'
import { Container, Button, Modal, Row, Col, Card } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  getnumofRcpts,
  getReceiptMetainfo
} from '../actions/dashboardActions.js'

import { getReceiptSpendTotal } from '../actions/metaActions.js'
import { getReceiptCategory } from '../actions/dashboardActions.js'
import { ThemeContext } from '../components/ThemeContext.js'
import { getQrcodeImageUrl } from '../apiUrl.js'

const DashBoard = () => {
  const { theme } = useContext(ThemeContext)
  let targetdir = ''

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [show, setShow] = useState(false)
  const [showWelcome, setShowWelcome] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleWelcomeClose = () => {
    localStorage.setItem('mr_welcome_seen', '1')
    setShowWelcome(false)
  }

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  // Set QR code path
  if (userInfo) {
    const { qrfile } = userInfo
    if (qrfile) {
      targetdir = getQrcodeImageUrl(qrfile)
    }
  }

  const countRcpt = useSelector((state) => state.countRcpt)
  const { countRecpt } = countRcpt

  const getRcptMeta = useSelector((state) => state.getRcptMeta)
  const { receiptMeta } = getRcptMeta

  const getReceiptSpend = useSelector((state) => state.getReceiptSpend)
  const { receiptspend } = getReceiptSpend

  const getRcptCategory = useSelector((state) => state.getRcptCategory)
  const { rcptCategory } = getRcptCategory

  let rcptNew = 0
  let rcptPersonal = 0
  let rcptBusiness = 0

  if (rcptCategory) {
    rcptCategory.forEach((item) => {
      if (item.rcategory === 'New') {
        rcptNew += 1
      } else if (item.rcategory === 'Personal') {
        rcptPersonal += 1
      } else if (item.rcategory === 'Business') {
        rcptBusiness += 1
      }
    })
  }

  // Show welcome modal only for new users (no receipts yet), once
  useEffect(() => {
    if (localStorage.getItem('mr_welcome_seen')) return
    if (countRecpt === undefined) return // still loading
    if (countRecpt === 0) {
      setShowWelcome(true)
    } else {
      // existing user — silently mark as seen so they never get it
      localStorage.setItem('mr_welcome_seen', '1')
    }
  }, [countRecpt])

  // Fetch data on load
  useEffect(() => {
    if (userInfo) {
      dispatch(getnumofRcpts())
      dispatch(getReceiptMetainfo(userInfo._id))
      dispatch(getReceiptSpendTotal(userInfo._id))
      dispatch(getReceiptCategory(userInfo._id))
    } else {
      navigate('/')
    }
  }, [dispatch, navigate, userInfo])

  return (
    <Container fluid='md' className='mt-3'>
      <Row>
        <Col className='my-2'>
          <h3 style={{ color: theme.text }}>DashBoard</h3>
        </Col>
        {countRecpt > 0 && (
          <Col className='my-2'>
            <Button
              size='sm'
              variant='outline-primary'
              onClick={handleShow}
              style={{
                borderColor: theme.accent,
                color: theme.accent,
                backgroundColor: 'transparent',
                border: `1px solid ${theme.accent}`
              }}
            >
              My QR
            </Button>
          </Col>
        )}
      </Row>

      <Row>
        <Modal size='sm' show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Scan QR</Modal.Title>
          </Modal.Header>
          <Modal.Body className='text-center'>
            {targetdir ? (
              <img
                src={targetdir}
                alt='User QR code'
                width='auto'
                height='auto'
              />
            ) : (
              <small>QR code is unavailable for this account.</small>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              size='sm'
              onClick={handleClose}
              style={{
                borderColor: theme.accent,
                color: theme.accent,
                backgroundColor: 'transparent',
                border: `1px solid ${theme.accent}`
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>

      {/* Welcome modal — shown once on first login */}
      <Modal show={showWelcome} onHide={handleWelcomeClose} centered>
        <Modal.Header
          closeButton
          style={{
            backgroundColor: theme.card,
            borderColor: theme.sidebarAccent
          }}
        >
          <Modal.Title style={{ color: theme.accent }}>
            Welcome to MicroReceipt 👋
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: theme.card, color: theme.text }}>
          <p>Here's how to start receiving digital receipts:</p>
          <ol style={{ paddingLeft: '1.25rem', color: theme.subtext }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong style={{ color: theme.text }}>Find your QR code</strong> —
              tap <em>My QR</em> above or visit your Profile.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong style={{ color: theme.text }}>
                Share it with a merchant
              </strong>{' '}
              — let them scan it at checkout.
            </li>
            <li>
              <strong style={{ color: theme.text }}>
                Receipts appear here
              </strong>{' '}
              — browse, categorise, and track your spend.
            </li>
          </ol>
        </Modal.Body>
        <Modal.Footer
          style={{
            backgroundColor: theme.card,
            borderColor: theme.sidebarAccent
          }}
        >
          <Button
            size='sm'
            onClick={() => {
              handleWelcomeClose()
              navigate('/profile')
            }}
            style={{
              borderColor: theme.accent,
              color: theme.accent,
              backgroundColor: 'transparent',
              border: `1px solid ${theme.accent}`
            }}
          >
            View My QR Code
          </Button>
          <Button size='sm' variant='secondary' onClick={handleWelcomeClose}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Zero-state get-started banner */}
      {countRecpt === 0 && (
        <Row className='mb-2'>
          <Col>
            <Card
              style={{
                backgroundColor: theme.card,
                borderColor: theme.accent,
                borderRadius: '8px'
              }}
            >
              <Card.Body>
                <Card.Title style={{ color: theme.accent }}>
                  Get started
                </Card.Title>
                <Card.Text style={{ color: theme.subtext }}>
                  You don't have any receipts yet. Share your QR code with a
                  merchant and your receipts will show up here.
                </Card.Text>
                <Button
                  size='sm'
                  onClick={handleShow}
                  style={{
                    borderColor: theme.accent,
                    color: theme.accent,
                    backgroundColor: 'transparent',
                    border: `1px solid ${theme.accent}`,
                    marginRight: '0.5rem'
                  }}
                >
                  My QR Code
                </Button>
                <Button
                  size='sm'
                  onClick={() => navigate('/profile')}
                  style={{
                    borderColor: theme.accent,
                    color: theme.accent,
                    backgroundColor: 'transparent',
                    border: `1px solid ${theme.accent}`
                  }}
                >
                  My Profile
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <Row>
        <Col className='my-2'>
          <Card
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Receipts</Card.Title>
              <Card.Text>You have {countRecpt} receipts.</Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() => navigate('/receipts')}
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                My Receipts
              </Button>
            </Card.Footer>
          </Card>
        </Col>
        <Col className='my-2'>
          <Card
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Spend</Card.Title>
              <Card.Text>To date you have spent {receiptspend || 0}</Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() => navigate('/charts')}
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                Spend Charts
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className='my-2'>
          <Card
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Receipt Categories</Card.Title>
              <ul className='mb-2'>
                {receiptMeta &&
                  receiptMeta.map((item, index) => (
                    <Card.Text key={index} as='div'>
                      <li>
                        {item.meta}: {item.count}
                      </li>
                    </Card.Text>
                  ))}
              </ul>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() =>
                  navigate('/category', { state: { category: 'New' } })
                }
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                View by Category
              </Button>
            </Card.Footer>
          </Card>
        </Col>
        <Col className='my-2'>
          <Card
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Receipt Type</Card.Title>
              <ul className='mb-2'>
                <li>New: {rcptNew}</li>
                <li>Personal: {rcptPersonal}</li>
                <li>Business: {rcptBusiness}</li>
              </ul>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() => navigate('/reports')}
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                Reports
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default DashBoard
